var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-doctor-card-calendar d-flex flex-column ga-4",
      attrs: { "data-qa": "lpu_doctors_list_calendar" },
    },
    [
      _c(_setup.DayTabs, {
        attrs: {
          "data-qa": "lpu_doctors_list_calendar_days",
          items: _vm.dayItems,
          "active-date": _vm.activeDate,
        },
        on: {
          select: function ($event) {
            return _setup.emit("select-day", $event)
          },
        },
      }),
      _vm._v(" "),
      _vm.activeDaySlots.length
        ? _c(_setup.SlotButtons, {
            attrs: {
              "data-qa": "lpu_doctors_list_calendar_slots",
              "slot-qa": "lpu_doctors_list_calendar_slot",
              "expand-qa": "lpu_doctors_list_calendar_slots_expand",
              slots: _vm.activeDaySlots,
              "is-disabled": _vm.isDisabled,
            },
            on: { click: (_nativeEvent, time) => _setup.emit("slot", time) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }